import React from 'react';
import HiddenForm from '../HiddenForm';

import {
    CATEGORY_ORDER_BY_DEFAULT,
    EVENTS,
} from '../../utilities/CONSTANTS';

class PinItem extends React.Component {

    componentDidMount() {
        if (!window.categoriesAndFoldersMap) {
            window.addEventListener(EVENTS.CATEGORIES_LOADED, () => this.forceUpdate());
        }
    }

    componentWillUnmount() { return window.removeEventListener(EVENTS.CATEGORIES_LOADED, () => this.forceUpdate()); }

    render() {

        const {
            pinToCategoryId, pinToFolderId, isPinned, pinId, pageId, externalResourceId, suggestionId, subcategoryId, questionId, documentId,
        } = this.props;

        if (!pinToCategoryId || !window.categoriesAndFoldersMap) {
            return null;
        }

        const categoryInfo = pinToFolderId
            ? window.categoriesAndFoldersMap[pinToCategoryId].folders[pinToFolderId]
            : window.categoriesAndFoldersMap[pinToCategoryId];

        if (!categoryInfo || categoryInfo.order_type === CATEGORY_ORDER_BY_DEFAULT.CUSTOM) {
            return null;
        }

        const fields = pageId
            ? [{ name: 'pageId', value: pageId }]
            : externalResourceId
                ? [{ name: 'externalResourceId', value: externalResourceId }]
                : documentId
                    ? [{ name: 'documentId', value: documentId }]
                    : suggestionId
                        ? [{ name: 'suggestionId', value: suggestionId }]
                        : questionId
                            ? [{ name: 'questionId', value: questionId }]
                            : [{ name: 'subcategoryId', value: subcategoryId }];

        const pinUrl = pinToFolderId
            ? `/teams/${window.teamDomain}/subcategories/${pinToFolderId}/pins`
            : `/teams/${window.teamDomain}/categories/${pinToCategoryId}/pins`;

        const pinText = pinToFolderId
            ? 'subcategory'
            : 'category';

        return !isPinned
            ? <HiddenForm method="post" url={pinUrl} value={`Pin to ${pinText}`} fields={fields} />
            : <HiddenForm method="delete" url={`${pinUrl}/${pinId}`} value={`Unpin from ${pinText}`} />;
    }
}
export default PinItem;
